import $ from 'jquery';

export default function kisWidgetsSliderGroup() {
    const
        previous = $().isWelshPage() ? 'Blaenorol' : 'Previous',
        next     = $().isWelshPage() ? 'Nesaf' : 'Next',
        $slick   = $('.kis-widgets-js-slick');

    $slick.slick({
        prevArrow: `<button class="slick-prev" aria-label="${previous}" type="button">${previous}</button>`,
        nextArrow: `<button class="slick-next" aria-label="${next}" type="button">${next}</button>`,
        infinite: false,
        speed: 100,
        dots: true,
        variableHeight: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });
}
